module.exports = __webpack_public_path__ + "static/media/bg-common-problem.dbb720a9.png";